module.exports = __webpack_public_path__ + "img/nodata_mylist-img.12548353.png";